export default __webpack_public_path__ + "static/media/team-4.a1e1c29f.jpg";